export default () => {
  var head = document.getElementsByTagName('head')[0]
  var script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-965268020'
  head.appendChild(script)
 

  Window.prototype.dataLayer = window.dataLayer || []
  let gtag: any = function() { window.dataLayer.push(arguments) }
  gtag('js', new Date())
  gtag('config', 'AW-965268020')
  Window.prototype.gtag = gtag
}
